export default "__VITE_ASSET__B5IrK488__"